import Points from '@/pages/Points'

export default {
  path: '/points',
  name: 'Points',
  component: Points
}



// WEBPACK FOOTER //
// ./src/router/points.js